module.exports = __webpack_public_path__ + "static/img/Inverter Specification.2762595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Inverter Specification.png
// module id = lPbZ
// module chunks = 1